import { render, staticRenderFns } from "./UiBanner.vue?vue&type=template&id=13f93c1d&"
import script from "./UiBanner.vue?vue&type=script&lang=ts&"
export * from "./UiBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports